<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<ng-container *ngIf="!hasPendingData">
    <div class="row">
        <div
            class="col-6 col-md-6 col-lg-4 mb-4"
            *ngIf="data != null"
        >
            <div class="drillpath">
                <span
                    class="item"
                    *ngFor="let item of drillPath; let isLast = last"
                    (click)="backDrill(item)"
                    >{{ item.username }}
                    <cmps-icon
                        svgIcon="chevron-right"
                        *ngIf="!isLast"
                    ></cmps-icon>
                </span>
            </div>
        </div>
        <div class="ml-auto col-6 col-md-6 col-lg-4 text-right mb-4">
            <label
                for="popUpDateRange"
                style="padding-top: 13px"
                >{{ i18n._709_DATE_RANGE | translate }}</label
            >
            <select
                class="custom-select ml-auto col-8 col-md-8 col-lg-8 mb-8"
                id="popUpDateRange"
                [ngModel]="selectedDateRange"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateWidget($event)"
            >
                <option
                    *ngFor="let i of options?.dateRanges; let ii = index"
                    [value]="ii"
                >
                    {{ i.label }}
                </option>
            </select>
        </div>
    </div>
    <div *ngIf="data == null">
        {{ i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
    <ngb-tabset
        [activeId]="'w-tab-' + options?.pillarIndex"
        #tabSet="ngbTabset"
        *ngIf="data != null"
    >
        <ng-template
            ngFor
            let-i
            let-ii="index"
            [ngForOf]="data.items"
        >
            <ngb-tab [id]="'w-tab-' + ii">
                <ng-template ngbTabTitle>{{ i.name }}</ng-template>
                <ng-template ngbTabContent>
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered table-hover cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th rowspan="2">
                                        {{ i18n._778_PERSON | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <ng-container
                                        *ngTemplateOutlet="calculatedColumns"
                                    ></ng-container>
                                </tr>
                                <tr>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            calculatedColumnsSubtitles
                                        "
                                    ></ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngTemplateOutlet="
                                        row;
                                        context: { j: i.user, rowTop: true }
                                    "
                                >
                                </ng-container>
                                <ng-container *ngIf="i.overall">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: {
                                                j: i.overall,
                                                rowTop: true
                                            }
                                        "
                                    >
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div
                        class="table-responsive"
                        *ngIf="i.team.length > 0"
                    >
                        <table
                            class="table table-striped table-sm table-bordered table-hover cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th rowspan="2">
                                        {{ i18n._778_PERSON | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <ng-container
                                        *ngTemplateOutlet="calculatedColumns"
                                    ></ng-container>
                                    <th
                                        class="sr-only"
                                        rowspan="2"
                                    >
                                        {{ i18n._746_DETAILS | translate }}
                                    </th>
                                </tr>
                                <tr>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            calculatedColumnsSubtitles
                                        "
                                    ></ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template
                                    ngFor
                                    let-j
                                    let-jj="index"
                                    [ngForOf]="i.team"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: { j: j, rowTop: false }
                                        "
                                    >
                                    </ng-container>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-tab>
        </ng-template>
    </ngb-tabset>
    <div
        class="card"
        *ngIf="!!currentDetail"
        #popupEl
    >
        <div class="card-header">
            <span>{{ i18n._784_COMPAS | translate }}</span>
            <button
                type="button"
                class="close ml-3"
                [attr.aria-label]="i18n._763_CLOSE | translate"
                (click)="currentDetail = null"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div class="card-body">
            <cmps-widget-mbna-compliance-details
                [user]="currentDetail"
                [widgetId]="options.widgetId"
                [activeTabId]="activeTabId"
            ></cmps-widget-mbna-compliance-details>
        </div>
    </div>
</ng-container>

<ng-template
    let-j="j"
    let-rowTop="rowTop"
    #row
>
    <tr (click)="showDetails($event, j)">
        <td
            class="text-nowrap"
            (click)="enterToUser($event, j)"
        >
            {{ j.username }}
        </td>
        <td class="text-nowrap">{{ j.populationName }}</td>
        <ng-template
            ngFor
            let-column
            [ngForOf]="columns"
        >
            <ng-container
                *ngTemplateOutlet="
                    calculatedColumnsData;
                    context: { data: j.categories[column.id]?.value }
                "
            >
            </ng-container>
            <td *ngIf="column.isOverall">
                {{
                    j.percentOfTeam == null
                        ? (i18n._842_N_A | translate)
                        : (j.percentOfTeam | percent: '1.1-1')
                }}
            </td>
        </ng-template>
    </tr>
</ng-template>

<ng-template #calculatedColumns>
    <ng-template
        ngFor
        let-column
        [ngForOf]="columns"
    >
        <ng-template
            [ngIf]="column.isOverall"
            [ngIfElse]="noOverral"
        >
            <th rowspan="2">{{ i18n._752_SCORE | translate }}</th>
            <th rowspan="2">{{ i18n._779_OPP_ITEMS | translate }}</th>
            <th rowspan="2">{{ i18n._780___OF_TEAM_OPP_ITEMS | translate }}</th>
        </ng-template>
        <ng-template #noOverral>
            <th colspan="2">{{ column.title }}</th>
        </ng-template>
    </ng-template>
</ng-template>

<ng-template #calculatedColumnsSubtitles>
    <ng-template
        ngFor
        let-column
        [ngForOf]="columns"
    >
        <ng-template [ngIf]="!column.isOverall">
            <th>{{ i18n._752_SCORE | translate }}</th>
            <th>{{ i18n._779_OPP_ITEMS | translate }}</th>
        </ng-template>
    </ng-template>
</ng-template>

<ng-template
    let-data="data"
    #calculatedColumnsData
>
    <ng-template
        [ngIf]="data"
        [ngIfElse]="noData"
    >
        <td>
            <span [ngStyle]="{ color: data.thresholdColor }">{{
                data.value | number: '1.0-0'
            }}</span>
            <cmps-icon
                [style.fill]="data.trendClass.split(' ')[0]"
                [svgIcon]="data.trendClass.split(' ')[1]"
                *ngIf="
                    data.trendClass?.length !== 0 &&
                    data.trendClass.split(' ').length > 1
                "
            ></cmps-icon>
        </td>
        <td>{{ data?.oppItems }}</td>
    </ng-template>
    <ng-template #noData>
        <td></td>
        <td></td>
    </ng-template>
</ng-template>
